import { useState, useEffect, useCallback, useMemo } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import headerImg from "./img/Andrew.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import './Banner.css';

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(30);
  const toRotate = useMemo(() => ["Software Developer", "FullStack Developer", "Mobile Developer", "Software Engineer"], []);
  const period = 2000;



  const tick = useCallback(() => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 3);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(100);
    }
  }, [isDeleting, loopNum, text, toRotate, period]);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [delta, tick, text])

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>

              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <div className="box">
                    <span className="tagline">Welcome to my Portfolio</span>
                    <h1>{`Hello! I'm Andrew`}<br></br> <span className="txt-rotate"><span className="wrap">{text}</span></span></h1>
                    <p>I am a software engineer with a passion for programming and a self-motivated attitude. <br></br>Looking for opportunities in the industry to utilize my skills and experience.<br></br><br></br><i>You miss 100% of the shots you don't take. - Wayne Gretzky</i></p>
                    <Nav.Link href="#connect">
                      <button>Let’s Connect <ArrowRightCircle size={25} /></button>
                    </Nav.Link>
                  </div>
                </div>}

            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img" loading="lazy" />
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

    </section >
  )
}
